
<mat-expansion-panel class="" (opened)="onPanelOpened(showSelected)" (closed)="onPanelClosed(showSelected)">
  <mat-expansion-panel-header class="disable_ripple">
    <mat-panel-title class="sx-filter__term__title" style="text-align: left;
      flex-grow: 1;
      line-height: 0;">
    <span class="sx-filter__term-header__title">{{filter.label}}</span>
    <span class="sx-filter__term-header__subtitle" *ngIf="showSelected">{{_label}}</span>
  </mat-panel-title>
  </mat-expansion-panel-header>
        
  <div class="date-filter-panel">
                  <div class="date-filter-panel-calendars">
                    <div class="date-filter-panel-calendars-content">
                      <div class="date-filter-panel-calendars-content__title">{{'core.datefilter.from'|translate}}</div>
                      <div class="date-filter-panel-calendars-content__calendar">
                        <!-- <app-sx-calendar (click)="$event.stopPropagation()"
                          [disableMonthView]="true" #fromCalendar [headerComponent]="headerFrom"></app-sx-calendar> -->
                          <app-sx-calendar (click)="$event.stopPropagation()" (selectedChange)="selectedFromChange($event)"
                            [disableMonthView]="isMonthPeriod()" #fromCalendar [headerComponent]="headerFrom"></app-sx-calendar>
                      </div>
                    </div>
                    <div class="date-filter-panel-calendars-content">
                      <div class="date-filter-panel-calendars-content__title">{{'core.datefilter.to'|translate}}</div>
                      <div class="date-filter-panel-calendars-content__calendar">
                        <!-- <app-sx-calendar (click)="$event.stopPropagation()" 
                          [disableMonthView]="true" #toCalendar [headerComponent]="headerTo"></app-sx-calendar> -->
                          <app-sx-calendar (click)="$event.stopPropagation()" (selectedChange)="selectedToChange($event)"
                            [disableMonthView]="isMonthPeriod()" #toCalendar [headerComponent]="headerTo"></app-sx-calendar>
                      </div>
                    </div>
                    <div hidden="true">
                      <mat-calendar></mat-calendar>
                    </div>
                  </div>
  </div>
      
</mat-expansion-panel>
